import React from 'react';
import { useNavigate } from "react-router-dom";
import { Alert } from 'antd';

export default function DisabledFeature() {
    const navigate = useNavigate();

    return (
        <Alert
            message="This feature is disabled for your current plan!"
            description={
                <>
                    In order to use this feature, you must{' '}
                    <span
                        className="fake-link"
                        onClick={() => navigate('/subscription/plans')}
                        style={{ color: '#fe6100' }}
                    >
                        upgrade
                    </span>{' '}
                    your plan.
                </>
            }
            type="warning"
            showIcon
        />
    );
}
